import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '@/styles/v4/tss-react';

const PRODUCT_IMAGE_WIDTH_PX = 150;
const PRODUCT_IMAGE_HEIGHT_PX = 84;
const PRICE_COLUMN_WIDTH_PX = 160;

const useStyles = makeStyles({ name: 'CheckoutOrderSummary' })(
  ({ palette, breakpoints, spacing }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
    },
    section: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
    },
    products: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    product: {
      display: 'flex',
      gap: spacing(1),
    },
    imageContainer: {
      flexShrink: 0,
      overflow: 'hidden',
      width: pxToRem(PRODUCT_IMAGE_WIDTH_PX),
      height: pxToRem(PRODUCT_IMAGE_HEIGHT_PX),
      borderRadius: pxToRem(8),
      backgroundColor: palette.semantic.bg.layer2,
    },
    image: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    productContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-end',
      minWidth: 0,
      [breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      },
    },
    breakdown: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
      paddingTop: spacing(0),
      borderTop: `${pxToRem(1)} solid ${palette.semantic.border.divider}`,
    },
    priceRow: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: spacing(-1),
    },
    price: {
      textAlign: 'right',
      [breakpoints.up('md')]: {
        width: pxToRem(PRICE_COLUMN_WIDTH_PX),
      },
    },
  })
);

export default useStyles;
